import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import { isArrayAndHasValue } from "../../../utils/functions";

const { Option } = Select;

const ExportAssignmentVehicleRow = ({
  field,
  idx,
  vehicle,
  add,
  remove,
  canRemove,
  onChange,
  buyerList,
  buyingOfficeList,
  onSearchBuyer,
  onSearchOffice,
  loadingPlaceOptions,
  arrivalPlaceOptions,
  challanList,
  onSearchChallan,
  vehicleTypes,
}) => {
  const rowId = vehicle?.unique_id ?? idx;
  const setValue = (value, key) => onChange(value, rowId, key);

  return (
    <tr key={field.key}>
      <td>
        <Form.Item {...field} name={[field.name, "buyer_id"]}>
          <Select
            placeholder="Buyer"
            size="small"
            showSearch
            allowClear
            style={{ width: 140 }}
            optionFilterProp="children"
            onSearch={onSearchBuyer}
            onChange={(value) => setValue(value, "buyer_id")}
            value={vehicle?.buyer_id}
          >
            {buyerList.map((buyer) => (
              <Option key={buyer.id} value={buyer.id}>
                {buyer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "buying_office_id"]}>
          <Select
            placeholder="Buying Office"
            size="small"
            showSearch
            allowClear
            style={{ width: 140 }}
            optionFilterProp="children"
            onSearch={onSearchOffice}
            onChange={(value) => setValue(value, "buying_office_id")}
            value={vehicle?.buying_office_id}
          >
            {buyingOfficeList.map((office) => (
              <Option key={office.id} value={office.id}>
                {office.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "vehicle_number"]}>
          <Input
            placeholder="Vehicle Number"
            size="small"
            style={{ width: 110 }}
            onChange={(event) => setValue(event.target.value, "vehicle_number")}
            value={vehicle?.vehicle_number}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "vehicle_size"]}>
          <Select
            placeholder="Vehicle Size"
            size="small"
            style={{ width: 100 }}
            onChange={(value) => setValue(value, "vehicle_size")}
            value={vehicle?.vehicle_size}
          >
            {["8 FT", "10 FT", "12 FT", "14 FT", "15 FT", "16 FT", "18 FT", "20 FT", "23 FT", "Others"].map(
              (size) => (
                <Option key={size} value={size}>
                  {size}
                </Option>
              ),
            )}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "vehicle_type"]}>
          <Select
            placeholder="Vehicle Type"
            size="small"
            style={{ width: 100 }}
            onChange={(value) => setValue(value, "vehicle_type")}
            value={vehicle?.vehicle_type}
          >
            {vehicleTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "empty_vehicle_arrival_time"]}>
          <CustomDatePicker
            size="small"
            style={{ width: 150 }}
            showTime
            format="DD-MMM-YYYY HH:mm:ss"
            onChange={(date) => setValue(date, "empty_vehicle_arrival_time")}
            value={vehicle?.empty_vehicle_arrival_time}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "driver_name"]}>
          <Input
            placeholder="Driver Name"
            size="small"
            style={{ width: 110 }}
            onChange={(event) => setValue(event.target.value, "driver_name")}
            value={vehicle?.driver_name}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "driver_cell_number"]}>
          <Input
            placeholder="Driver Cell No."
            size="small"
            style={{ width: 110 }}
            onChange={(event) => setValue(event.target.value, "driver_cell_number")}
            value={vehicle?.driver_cell_number}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "driving_license_number"]}>
          <Input
            placeholder="License"
            size="small"
            style={{ width: 110 }}
            onChange={(event) =>
              setValue(event.target.value, "driving_license_number")
            }
            value={vehicle?.driving_license_number}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "loading_place"]}>
          <Select
            placeholder="Place of Loading"
            size="small"
            allowClear
            style={{ width: 130 }}
            onChange={(value) => setValue(value, "loading_place")}
            value={vehicle?.loading_place}
          >
            {loadingPlaceOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "dispatch_time"]}>
          <CustomDatePicker
            size="small"
            style={{ width: 150 }}
            showTime
            format="DD-MMM-YYYY HH:mm:ss"
            onChange={(date) => setValue(date, "dispatch_time")}
            value={vehicle?.dispatch_time}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "challan_id"]}>
          <Select
            showSearch
            allowClear
            placeholder="Challan No."
            size="small"
            style={{ width: 120 }}
            filterOption={false}
            onSearch={onSearchChallan}
            onChange={(value) => setValue(value, "challan_id")}
            value={vehicle?.challan_id}
          >
            {isArrayAndHasValue(challanList) &&
              challanList.map((item, index) => (
                <Option key={item?.id || index} value={item?.id}>
                  {item?.challan_no || ""}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "security_bolt_seal_number"]}>
          <Input
            placeholder="Seal No."
            size="small"
            style={{ width: 110 }}
            onChange={(event) =>
              setValue(event.target.value, "security_bolt_seal_number")
            }
            value={vehicle?.security_bolt_seal_number}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "delivery_place"]}>
          <Select
            placeholder="Place of Arrival"
            size="small"
            allowClear
            style={{ width: 130 }}
            onChange={(value) => setValue(value, "delivery_place")}
            value={vehicle?.delivery_place}
          >
            {arrivalPlaceOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "export_carton"]}>
          <InputNumber
            placeholder="Carton"
            size="small"
            min={0}
            precision={0}
            style={{ width: 90 }}
            onChange={(value) => setValue(value, "export_carton")}
            value={vehicle?.export_carton}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "garment_piece_qty"]}>
          <InputNumber
            placeholder="Pieces"
            size="small"
            min={0}
            precision={0}
            style={{ width: 90 }}
            onChange={(value) => setValue(value, "garment_piece_qty")}
            value={vehicle?.garment_piece_qty}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item {...field} name={[field.name, "arrival_date"]}>
          <CustomDatePicker
            size="small"
            style={{ width: 150 }}
            showTime
            format="DD-MMM-YYYY HH:mm:ss"
            onChange={(date) => setValue(date, "arrival_date")}
            value={vehicle?.arrival_date}
          />
        </Form.Item>
      </td>
      <td>
        <CustomDatePicker
          style={{ width: 150 }}
          size="small"
          showTime
          format="DD-MMM-YYYY HH:mm:ss"
          disabled
          value={vehicle?.unloading_date}
        />
      </td>
      <td>
        <Button
          icon={<PlusCircleOutlined />}
          onClick={() => add({ unique_id: rowId + 1 })}
          style={{ color: "green" }}
        />
      </td>
      <td>
        <Button
          icon={<MinusCircleOutlined />}
          onClick={() => remove(field.name)}
          style={{ color: "red" }}
          disabled={!canRemove}
        />
      </td>
    </tr>
  );
};

export default ExportAssignmentVehicleRow;
